const _ = "_card_8mcml_1", l = "_icon_8mcml_53", c = "_arrow_8mcml_54", m = "_sm_8mcml_82", a = "_lg_8mcml_88", o = "_addIcon_8mcml_108", r = {
  card: _,
  icon: l,
  arrow: c,
  "has-icon": "_has-icon_8mcml_60",
  "has-arrow-side": "_has-arrow-side_8mcml_63",
  "has-arrow-under": "_has-arrow-under_8mcml_70",
  sm: m,
  lg: a,
  "blue-blue": "_blue-blue_8mcml_92",
  "blue-yellow": "_blue-yellow_8mcml_93",
  "white-yellow": "_white-yellow_8mcml_98",
  "white-blue": "_white-blue_8mcml_103",
  addIcon: o,
  "add-primary": "_add-primary_8mcml_123",
  "add-critical": "_add-critical_8mcml_124"
};
export {
  o as addIcon,
  c as arrow,
  _ as card,
  r as default,
  l as icon,
  a as lg,
  m as sm
};
//# sourceMappingURL=card.module.less.js.map
